import { Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Image from 'next/image';

interface Props {
  value?: string;
  className?: string;
  onChange?(val: string): void;
  error?: string;
  required?: boolean;
  title?: string;
  name?: string;
  icons: string[];
}

export const SelectorIcon: React.FC<Props> = ({
  value,
  className,
  onChange,
  error,
  required = false,
  title,
  name,
  icons,
}) => {
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    if (!value) onChange(icons[0]);
  }, []);

  return (
    <div className={className}>
      <label htmlFor={name} className="text-gray_800-700 mb-2">
        {title} {required && <span className="text-error">*</span>}
      </label>

      <Popover
        open={open}
        onOpenChange={handleOpenChange}
        overlayInnerStyle={{ padding: 0 }}
        content={
          <StyleDiv>
            {icons.map((icon, index) => (
              <StyleButton
                className={icon === value ? 'active' : ''}
                onClick={() => {
                  onChange(icon);
                  hide();
                }}
                key={index}
              >
                <Image src={icon} alt="icon" width={20} height={20} />
              </StyleButton>
            ))}
          </StyleDiv>
        }
        placement="bottom"
        trigger="click"
      >
        <StyleSelect>
          <Image src={value} width={24} height={24} alt="" />
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 11L12 15L8 11"
              stroke="#6C727F"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </StyleSelect>
      </Popover>

      {error && <span className="text-error fs-7">{error}</span>}
    </div>
  );
};

const StyleDiv = styled.div`
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  flex-wrap: wrap;
  gap: 12px;
  overflow-y: auto;
`;

const StyleSelect = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 8px 16px;
  gap: 12px;
  border-radius: 6px;
  border: 1px solid #d3d5da;
  cursor: pointer;
`;

const StyleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  background: unset;
  padding: 4px;
  border-radius: 4px;

  &.active {
    border: 1px solid #4338ca;
  }
`;
